import { render, staticRenderFns } from "./priceAddModule.vue?vue&type=template&id=045cf4aa&scoped=true"
import script from "./priceAddModule.vue?vue&type=script&lang=js"
export * from "./priceAddModule.vue?vue&type=script&lang=js"
import style0 from "./priceAddModule.vue?vue&type=style&index=0&id=045cf4aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045cf4aa",
  null
  
)

export default component.exports